import React from "react";

import Hero from "../components/Hero";

const Home = () => <Hero />;

export default Home;
